export default __webpack_public_path__ + "static/media/Pathfinder's Loop.e739bbea.jpg";